const state = {
  seatStatusWs: null, //坐席状态长链
  member_id: null, //用户id
  isaicalling: false, //是否通话中(预测式外呼)
  isseatcalling: null, //是否通话中(坐席)
  WebSocketUrl: null, //长链
}

const mutations = {
  SET_IS_AI_CALLING: (state, isaicalling) => {
    state.isaicalling = isaicalling
  },
  SET_IS_SEAT_CALLING: (state, isseatcalling) => {
    state.isseatcalling = isseatcalling
  },
  SET_MEMBER_ID: (state, member_id) => {
    state.member_id = member_id
  },
  SET_WEBSOCKET_URL: (state, WebSocketUrl) => {
    state.WebSocketUrl = WebSocketUrl
  },
}

const actions = {
  initSeatStatusWs({ dispatch, commit, state }, { WebSocketUrl, member_id }) {
    commit("SET_WEBSOCKET_URL", WebSocketUrl);
    commit("SET_MEMBER_ID", member_id);
    state.seatStatusWs = new WebSocket(state.WebSocketUrl);
    state.seatStatusWs.onopen = function(res){
      state.seatStatusWs.send('{"cmd":"yc_out","member_id":"'+ member_id +'"}');
    }
    state.seatStatusWs.onmessage = function(res){
      let wss_data = JSON.parse(res.data);
      let result = wss_data.agentStatus
      if (result.status == '通话中') {
        commit("SET_IS_AI_CALLING", true) 
      } else {
        commit("SET_IS_AI_CALLING", false) 
      }
      // if (wss_data.hasOwnProperty('seat_status')) {//获取来电通话状态
      //   if (wss_data.seat_status == 0) {
      //     //dispatch("closeSeatStatusWs")
      //   }
      //   commit("SET_IS_AI_CALLING", wss_data.seat_status == 1 ? true : false) 
      // } 
    }
    state.seatStatusWs.onclose = function (res) {
      console.error("Connection closed...");
    }

    state.seatStatusWs.onerror = function (res) {
      console.error("Connection error...");
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/call.js